// callback is used as the single redirect point from auth0 to all ketch pages
export const callback = {
  root: {
    pattern: '/callback',
    getURL: () => '/callback',
  },
}
